import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { CHANNELS_MAX_FORM_LIMIT } from '../lib/constants';

export const useFormSchema = () => {
  const { t } = useTranslation('translation');

  const requiredMessage = t('common.formErrors.required');
  const maxNameMessage = t('common.formErrors.stringMaxLen', {
    max: CHANNELS_MAX_FORM_LIMIT.name,
  });
  const maxDescriptionMessage = t('common.formErrors.stringMaxLen', {
    max: CHANNELS_MAX_FORM_LIMIT.description,
  });
  const maxStartMessageMessage = t('common.formErrors.stringMaxLen', {
    max: CHANNELS_MAX_FORM_LIMIT.start_message,
  });

  const baseFields = {
    name: z
      .string()
      .trim()
      .min(1, requiredMessage)
      .max(CHANNELS_MAX_FORM_LIMIT.name, maxNameMessage),
    isActive: z.boolean(),
    agentId: z.coerce
      .number({ required_error: requiredMessage })
      .int(t('common.formErrors.integer'))
      .min(1, t('common.formErrors.minNumber', { min: 1 })),
    description: z
      .string()
      .trim()
      .max(CHANNELS_MAX_FORM_LIMIT.description, maxDescriptionMessage)
      .optional(),
  };

  const botWithStartMessageSchema = z
    .object({
      ...baseFields,
      token: z.string().trim().min(1, requiredMessage),
      startMessage: z
        .string()
        .trim()
        .max(CHANNELS_MAX_FORM_LIMIT.start_message, maxStartMessageMessage)
        .optional(),
    })
    .passthrough();

  const telegramSchema = botWithStartMessageSchema;
  const maxSchema = botWithStartMessageSchema;

  const vkSchema = z
    .object({
      ...baseFields,
      token: z.string().trim().min(1, requiredMessage),
    })
    .passthrough();

  const widgetSchema = z
    .object({
      ...baseFields,
      host: z.string().trim().min(1, requiredMessage),
      presetId: z.number().int().min(1).nullable().optional(),
    })
    .passthrough();

  const avitoSchema = z
    .object({
      ...baseFields,
      clientId: z.string().trim().min(1, requiredMessage),
      clientSecret: z.string().trim().min(1, requiredMessage),
    })
    .passthrough();

  return {
    telegramSchema,
    vkSchema,
    widgetSchema,
    maxSchema,
    avitoSchema,
  };
};
